import { Toast } from "bootstrap";
import { getLocalizedText } from "../common/translations";
import ControlBase, { IControlBaseOptions } from "./controlBase";
import { createToast } from "../common/toasts";

interface IOrthomapControlOptions extends IControlBaseOptions {
    mapToggledHandler?: (isVisible: boolean) => void,
    opacityChangedHandler?: (opacity: number) => void
}

export default class OrthomapControl extends ControlBase {
    ortoEnabled: boolean;
    ortoAvailable: boolean;
    private slider: HTMLInputElement;
    private toggleHandler?: (isVisible: boolean) => void;
    private opacityChangedHandler?: (opacity: number) => void;
    private tooltipToast: Toast;

    constructor(options: IOrthomapControlOptions) {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Bootstrap ikona Layers https://icons.getbootstrap.com/icons/layers/
        svg.innerHTML = `<path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0l3.515-1.874zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"/>`;
        svg.setAttribute("width", "24px");
        svg.setAttribute("height", "24px");
        svg.setAttribute("viewBox", "0 0 16 16");
        options.collapsedSymbol = svg;
        let svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // upravena ikona Layers
        svg2.innerHTML = `<path d="M 8 1.5 A 0.5 0.5 0 0 0 7.765625 1.5585938 L 6.2832031 2.3496094 L 7.3046875 2.9375 L 8 2.5664062 L 9.125 3.1660156 L 10.171875 2.5917969 L 8.234375 1.5585938 A 0.5 0.5 0 0 0 8 1.5 z M 5.2402344 2.90625 L 3.2089844 3.9882812 L 4.2304688 4.578125 L 6.2597656 3.4941406 L 5.2402344 2.90625 z M 11.228516 3.15625 L 10.179688 3.7285156 L 12.285156 4.8515625 L 13.333984 4.2792969 L 11.228516 3.15625 z M 2.1679688 4.5429688 L 0.265625 5.5585938 A 0.5 0.5 0 0 0 0.265625 6.4414062 L 1.7246094 7.21875 L 2.7734375 6.6464844 L 1.5625 6 L 3.1875 5.1328125 L 2.1679688 4.5429688 z M 14.390625 4.8417969 L 13.341797 5.4160156 L 14.4375 6 L 13.486328 6.5078125 L 14.507812 7.0957031 L 15.734375 6.4414062 A 0.5 0.5 0 0 0 15.734375 5.5585938 L 14.390625 4.8417969 z M 12.443359 7.0644531 L 10.412109 8.1464844 L 11.433594 8.7363281 L 11.75 8.5664062 L 14.4375 10 L 8 13.433594 L 1.5625 10 L 4.25 8.5664062 L 4.8847656 8.90625 L 5.9335938 8.3320312 L 3.8300781 7.2089844 L 2.78125 7.7832031 L 3.1875 8 L 0.26367188 9.5585938 A 0.5 0.5 0 0 0 0.26367188 10.441406 L 7.7636719 14.441406 A 0.5 0.5 0 0 0 8.234375 14.441406 L 15.734375 10.441406 A 0.5 0.5 0 0 0 15.734375 9.5585938 L 12.8125 8 L 13.462891 7.6523438 L 12.443359 7.0644531 z M 9.3710938 8.703125 L 8 9.4335938 L 6.9902344 8.8945312 L 5.9414062 9.46875 L 7.765625 10.441406 A 0.5 0.5 0 0 0 8.234375 10.441406 L 10.390625 9.2910156 L 9.3710938 8.703125 z"/>`;
        svg2.setAttribute("width", "24px");
        svg2.setAttribute("height", "24px");
        svg2.setAttribute("viewBox", "0 0 16 16");
        options.symbol = svg2;
        options.collapsible = true;
        options.clickHandler = () => this.handleButtonClick();
        options.tooltipText = getLocalizedText("controlLayers");
        super(options);

        this.slider = document.createElement("input");
        this.slider.id = "map-opacity-control";
        this.slider.setAttribute("orient", "vertical");
        this.slider.type = "range";
        this.slider.min = "0";
        this.slider.max = "100";
        this.slider.value = "50";

        this.collapsibleContent.appendChild(this.slider);
        this.tooltipToast = createToast("", "opacityTooltip");
        this.container.classList.add("collapsible-with-tooltip");
        this.container.classList.add("opacity-slider");

        this.toggleHandler = options.mapToggledHandler;
        this.opacityChangedHandler = options.opacityChangedHandler;
        this.ortoEnabled = false;

        this.slider.addEventListener("input", this.handleOpacityChanged.bind(this));
    }

    reset(enabled: boolean, visible: boolean) {
        this.ortoEnabled = enabled && visible;
        this.ortoAvailable = enabled;
        this.slider.removeEventListener("input", this.handleOpacityChanged);
        this.slider.value = "30";
        this.slider.addEventListener("input", this.handleOpacityChanged.bind(this));
        this.container.classList.remove("control-collapsed");
        this.slider.disabled = !enabled;
        this.button.disabled = !enabled;
        if (enabled && !visible)
            this.boundToggleCollapsedState();
        this.updateTooltipText();
    }

    private handleButtonClick() {
        this.ortoEnabled = !this.ortoEnabled;
        if (this.toggleHandler) {
            this.toggleHandler(this.ortoEnabled);
        }
        this.updateTooltipText();
    }

    private handleOpacityChanged() {
        if (this.opacityChangedHandler) {
            this.opacityChangedHandler(+this.slider.value/100.0);
        }
        let textDiv = document.querySelector("#opacityTooltip .toast-body span") as HTMLElement;
        if (textDiv) {
            textDiv.innerText = getLocalizedText("controlTransparency")+" - "+this.slider.value+"%";
        }
        if (this.ortoEnabled && !this.tooltipToast.isShown()) {
            this.tooltipToast.show();
        }
    }

    private updateTooltipText() {
        if (this.tooltipTextDiv) {
            if (this.ortoEnabled || this.ortoAvailable) {
                this.tooltipTextDiv.innerText = getLocalizedText("controlLayers");
            } else {
                this.tooltipTextDiv.innerText = getLocalizedText("controlLayers")+" - "+getLocalizedText("controlOrthomapUnavailable");
            }
        }
    }
}